export const LINKEDIN_CONVERSIONS_ID: {
  [key: string]: number;
} = {
  'Enterprise Lead Registered': 5476746,
  'Sign Up': 9070762,
  'Plan Upgraded from Free': 12041618,
};

export const REDDIT_CONVERSIONS_ID: {
  [key: string]: string;
} = {
  'Sign Up': 'SignUp',
  'Plan Upgraded from Free': 'Purchase',
};

export const QUORA_CONVERSIONS_ID: {
  [key: string]: string;
} = {
  'Plan Upgraded from Free': 'Purchase',
};
